import { render, staticRenderFns } from "./ClassesDetailTabs.vue?vue&type=template&id=644f0851&scoped=true&"
import script from "./ClassesDetailTabs.vue?vue&type=script&lang=js&"
export * from "./ClassesDetailTabs.vue?vue&type=script&lang=js&"
import style0 from "./ClassesDetailTabs.vue?vue&type=style&index=0&id=644f0851&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f0851",
  null
  
)

export default component.exports